/**
 * Created by rxsl-106 on 2017/6/1.
 */
import api from './index'

let exports = {};

// ======================= 共享配件仓库 ========================

exports.getShareAccWarehouseInfo = function (params, callback) {// 获取仓库详情
    api.get('/share/acc/warehouse/info/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getShareAccWarehouseList = function (data, callback) {// 获取仓库列表
    api.post('/share/acc/warehouse/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getShareAccWarehousePageList = function (data, callback) {// 获取仓库分页列表
    api.post('/share/acc/warehouse/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveShareAccWarehouse = function (data, callback) {// 新增仓库信息
    api.post('/share/acc/warehouse/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShareAccWarehouse = function (data, callback) {// 修改仓库信息
    api.post('/share/acc/warehouse/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteShareAccWarehouse = function (data, callback) {// 删除仓库信息
    api.post('/share/acc/warehouse/delete/do')
    .data(data)
    .done(callback)
    .go();
};

// ==================== 共享配件库存 =============================
//
// 获取配件库存配件ids BY 仓库id
exports.getShareAccStockAccIdsByWarehouseId = function (params, callback) {
    api.get('/share/acc/accIds/by/warehosueId')
    .params(params)
    .done(callback)
    .go();
};
// 保存库存信息
exports.saveShareAccStockList = function (data, callback) {
    api.post('/share/acc/list/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getShareAccStockList = function (data, callback) {// 共享配件库存分页列表
    api.post('/share/acc/stock/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccStockPageList = function (data, callback) {// 擦擦
    api.post('/share/acc/stock/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccStockListByMerchantType = function (data, callback) {// 共享配件库存分页列表
    api.post('/share/acc/stock/list/get/by/merchantType')
    .data(data)
    .done(callback)
    .go();
};

exports.getShareAccStockById = function (params, callback) {// 共享配件库存
    api.get('/share/acc/stock/get/by/id')
    .params(params)
    .done(callback)
    .go();
};

exports.doUpdateShareAccStockStockValue = function (data, callback) {// 共享配件库存
    api.post('/share/acc/stock/stockValve/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccIoRecordList = function (data, callback) {// 共享配件库存
    api.post('/share/acc/io/record/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getShareAccUseturnVoucherItemList = function (data, callback) {// 擦擦
    api.post('/share/acc/useturn/voucher/item/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccUseturnVoucherItemListByCustMerchantType = function (data, callback) {// 擦擦
    api.post('/share/acc/useturn/voucher/item/list/get/custMerchantType')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShareAccStockNormalQuantity = function (data, callback) {// 修改数量
    api.post('/share/acc/stock/normalQuantity/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getShareAccWarehouseListByCustMerchantType = function (data, callback) {// 修改数量
    api.post('/share/acc/warehouse/list/get/by/custMerchantType')
    .data(data)
    .done(callback)
    .go();
};

// ======================= 共享配件（授权）客户机构 ========================

exports.getShareAccCustOrgPageList = function (data, callback) {// 获取-共享配件（授权）客户机构-分页列表
    api.post('/share/acc/custOrg/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveShareAccCustOrg = function (data, callback) {// 保存-共享配件（授权）客户机构
    api.post('/share/acc/custOrg/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteShareAccCustOrg = function (data, callback) {// 删除-共享配件（授权）客户机构
    api.post('/share/acc/custOrg/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ========================== 共享配件调拨单 =======================

exports.getShareAccTransVoucher = function (params, callback) {// 获取-共享配件调拨单-详情
    api.get('/share/acc/trans/voucher/info/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getShareAccTransVoucherList = function (data, callback) {// 获取-共享配件调拨单-分页列表
    api.post('/share/acc/trans/voucher/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveShareAccTransVoucher = function (data, callback) {// 新增-共享配件调拨单
    api.post('/share/acc/trans/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.applyShareAccTransVoucher = function (data, callback) {// 申请-共享配件调拨单
    api.post('/share/acc/trans/voucher/apply/do')
    .data(data)
    .done(callback)
    .go();
};

exports.auditShareAccTransVoucher = function (data, callback) {// 审核-共享配件调拨单
    api.post('/share/acc/trans/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteShareAccTransVoucher = function (data, callback) {// 删除-共享配件调拨单
    api.post('/share/acc/trans/voucher/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccTransVoucherListExportUrl = function (data, callback) {// 共享配件调拨单-导出
    api.post('/share/acc/trans/voucher/list/export/url/get')
    .data(data)
    .done(callback)
    .go();
};
// ================================== 共享配件调配申请单 ==================================
exports.getShareAccAdjustApplyFormById = function (params, callback) {
    api.get('/share/acc/adjust/apply/info/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.getShareAccAdjustApplyFormByIdForAudit = function (data, callback) {
    api.post('/share/acc/adjust/apply/info/for/audit/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccAdjustApplyFormList = function (data, callback) {
    api.post('/share/acc/adjust/apply/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyFormForAudit = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/for/audit/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccCustOrgPageListGroupRetailer = function (data, callback) {
    api.post('/share/acc/custOrg/page/list/get/group/retailer')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccAdjustApplyCustMerchantTypeFormList = function (data, callback) {
    api.post('/share/acc/adjust/apply/page/list/get/by/custMerchantType')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveShareAccAdjustApplyForm = function (data, callback) {
    api.post('/share/acc/adjust/apply/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyForm = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyFormForApply = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/for/apply/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyFormForDone = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/for/done/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteShareAccAdjustApplyForm = function (data, callback) {
    api.post('/share/acc/adjust/apply/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccServicerList = function (data, callback) {   // 共享配件服务商
    api.post('/share/acc/servicer/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccWarehouseList = function (data, callback) {   // 共享配件仓库
    api.post('/share/acc/warehouse/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getAdjustApplyFormFileList = function (data, callback) {   // 附件信息
    api.post('/share/acc/adjust/file/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getSpecificAccList = function (data, callback) {   // 根据共享库存信息查询个体化信息
    api.post('/share/acc/specific/acc/list')
    .data(data)
    .done(callback)
    .go();
};







export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shareAcc.js
// module id = 34
// module chunks = 1